// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionsCell_root__2T4cT","btn":"ActionsCell_btn__1AAIS"};